import { findOverflowScrollParent } from '@atlaskit/editor-common/Popup/utils';
import type { EditorAppearance } from '@atlaskit/editor-common/types/editor-appearance';

/**
 * Returns the scroll target for a collapsible loading bar.
 *
 * The collapse experiment must be enabled before a target is selected. Comment
 * appearances then listen on `window` in capture phase, which sees both page
 * scrolls and scrolls from a nested comment container while preserving the
 * existing comment-relative fixed positioning supplied by `Container`.
 */
export const getLoadingBarScrollContainer = (
	appearance: EditorAppearance | undefined,
	editorElement: HTMLElement,
	isEnabled: boolean,
): HTMLElement | Window | undefined => {
	if (!isEnabled) {
		return undefined;
	}

	const windowScrollContainer = typeof window !== 'undefined' ? window : undefined;

	if (appearance === 'comment') {
		return windowScrollContainer;
	}

	return findOverflowScrollParent(editorElement) || windowScrollContainer;
};
